<script>
    import TagGroup from '@/components/page-tag-edit/TagGroup.vue';

    export default {
        computed: {
            tagsGroups() {return this.$store.getters.TAGS_GROUP_BY_NAME},
            tagCount() {return this.$store.getters.TAGS_COUNT},
        },
        components: {
            TagGroup: TagGroup,
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <TagGroup
            v-for="(tagsValue, tagsIndex) in tagsGroups" :key="tagsIndex"
            :tags="tagsValue"
            :groupHeader="tagsIndex"
        />
    </div>
</template>